module.exports = __webpack_public_path__ + "peru.jpg?4207e22963d602878e61eaf10d334400";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/peru.jpg
// module id = 185
// module chunks = 0